import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import config from '../config/config';
import authHeader from '../config/authHeader';
import { useAuth } from './AuthContext';

const NotificationsContext = createContext();

export const NotificationsProvider = ({ children, pollMs = 60000 }) => {
    const { isLoggedIn } = useAuth();
    const [notifications, setNotifications] = useState([]);
    const [unread, setUnread] = useState(0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const fetchNotifications = useCallback(async () => {
        if (!isLoggedIn) return;
        setLoading(true);
        setError('');
        try {
            const res = await fetch(`${config.apiBaseUrl}/4DACTION/KST_getUserNotifications`, { headers: authHeader() });
            if (!res.ok) throw new Error('Fail notif');
            const data = await res.json();
            const list = Array.isArray(data) ? data : [];
            setNotifications(list);
            setUnread(list.filter(n => !n.lu && !n.read).length);
        } catch (e) {
            setError('Impossible de récupérer les notifications.');
        } finally {
            setLoading(false);
        }
    }, [isLoggedIn]);

    useEffect(() => {
        if (!isLoggedIn) { setNotifications([]); setUnread(0); return; }
        fetchNotifications(); // 1er chargement
        const id = setInterval(fetchNotifications, pollMs); // polling
        return () => clearInterval(id);
    }, [isLoggedIn, fetchNotifications, pollMs]);

    const markAsRead = async (id) => {
        try {
            // backend: KST_markNotificationRead?id=...
            await fetch(`${config.apiBaseUrl}/4DACTION/KST_markNotificationRead?id=${encodeURIComponent(id)}`, {
                method: 'POST',
                headers: authHeader()
            });
            setNotifications(prev => prev.map(n => n.id === id ? { ...n, lu: true, read: true } : n));
            setUnread(prev => Math.max(0, prev - 1));
        } catch(e) {
            
        }
    };

    return (
        <NotificationsContext.Provider value={{
            notifications, unread, loading, error,
            refresh: fetchNotifications,
            markAsRead,
        }}>
            {children}
        </NotificationsContext.Provider>
    );
};

export const useNotifications = () => useContext(NotificationsContext);
